export default "<span class=\"badge\">Default Badge</span>\n<span class=\"badge badge-sm\">Default Badge Small</span>\n";